import { styled } from '@styles/stitches';

export const Trigger = styled('div', {
  cursor: 'pointer',
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  i: {
    fontSize: 18,
    color: '$secondaryFill',
  },

  '&:hover': {
    i: {
      color: '$primaryFill',
    },
  },

  '&:focus': {
    outline: 'none',
    i: {
      color: '$primaryFill',
    },
  },

  variants: {
    hasNotification: {
      true: {
        position: 'relative',

        '&:after': {
          position: 'absolute',
          top: 0,
          right: 0,
          content: '',
          width: 8,
          height: 8,
          backgroundColor: '$primaryHighlight',
          borderRadius: 9999,
        },
      },
    },
  },
});

export const Content = styled('div', {
  backgroundColor: '$primaryBackground',
  borderRadius: 5,
  overflow: 'hidden',
  border: '0.5px solid $colors$primaryBorder',
  boxShadow: '0px 5px 15px -5px hsla(206,22%,7%,.15)',
});

export const Scrollable = styled('div', {
  overflowY: 'auto',
  minHeight: 130,
  maxHeight: 325,
});

export const Item = styled('div', {
  display: 'flex',
  borderBottom: '1px solid $colors$primaryBorder',

  '&:last-child': {
    marginBottom: 0,
    borderBottom: 'none',
  },

  '&:focus': {
    outline: 'none',
    backgroundColor: '$secondaryBackground',
  },
});
